<template>
  <form-block
    :title="tr('Campaign name')"
    :description="tr('The campaign name is automatically generated from the name of the automation. However, you have the option to set a custom name prefix for the campaign, allowing for easier identification and management of your campaigns.')"
  >
    <div class="flex flex-col gap-1.5">
      <ui-label for="campaign-name-prefix">{{ tr('Name prefix') }}</ui-label>
      <ui-input
        id="campaign-name-prefix"
        v-model="entity.settings.campaign_name_prefix"
        placeholder="[Infinite.ad]"
        :disabled="disabled"
      />
      <p class="m-0 text-sm text-muted-foreground">
        {{ tr('Campaign name preview') }}: <span class="text-foreground">{{ entity.campaignName }}</span>
      </p>
    </div>
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';

export default {
  name: 'CampaignNameBlock',
  mixins: [ RuleFormBlockMixin ],
};
</script>
